import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("iaaj_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("iaaj_token", t);
  else localStorage.removeItem("iaaj_token");
};

export const fileUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http") || path.startsWith("/")) return path;
  const token = localStorage.getItem("iaaj_token");
  return `${API}/files/${path}${token ? `?auth=${token}` : ""}`;
};

// --- Optimized image derivatives (thumb ~400 / medium ~1000 / large ~1600) ---
const _order = { thumb: ["thumb", "medium", "large"], medium: ["medium", "large", "thumb"], large: ["large", "medium", "thumb"] };
export const mediaPath = (rec, size = "medium") => {
  const d = rec?.derivatives || {};
  for (const s of (_order[size] || ["medium"])) if (d[s]?.path) return d[s].path;
  return rec?.thumb_path || rec?.storage_path || "";
};
export const mediaUrl = (rec, size = "medium") => fileUrl(mediaPath(rec, size));
export const mediaSrcSet = (rec) => {
  const d = rec?.derivatives || {};
  const parts = [];
  if (d.thumb?.path) parts.push(`${fileUrl(d.thumb.path)} ${d.thumb.w || 400}w`);
  if (d.medium?.path) parts.push(`${fileUrl(d.medium.path)} ${d.medium.w || 1000}w`);
  if (d.large?.path) parts.push(`${fileUrl(d.large.path)} ${d.large.w || 1600}w`);
  return parts.join(", ");
};

export function apiErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
